import { render, staticRenderFns } from "./ScreenerButton.vue?vue&type=template&id=067693c8&scoped=true&"
import script from "./ScreenerButton.vue?vue&type=script&lang=js&"
export * from "./ScreenerButton.vue?vue&type=script&lang=js&"
import style0 from "./ScreenerButton.vue?vue&type=style&index=0&id=067693c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../var/www/html/film-screening-production/avails/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067693c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../var/www/html/film-screening-production/avails/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
